import { DeepClone } from "../../insole-web-common/src/util.js";
import { UpdatePosting } from "./posting.js";
import { UpdateShellModifications } from "./shell-modifications.js";
import { middleEmbossedTextOffset } from "./values.js";
function GetDefaultFootScanParameters() {
    return {
        scanMode: "semi-weighted",
        upDirection: "NegZ",
        forwardDirection: "Y",
        rightDirection: "X",
        twistCorrection: "auto",
    };
}
export function ConvertPrescriptionToMetadata(prescription, leftFootParameters, rightFootParameters) {
    var _a;
    CheckCompatibleTools(prescription);
    const leftInsoleParameters = {};
    const rightInsoleParameters = {};
    const converted = {
        leftFootMetadata: {
            insoleParameters: leftInsoleParameters,
            footScanParameters: GetDefaultFootScanParameters(),
            measurementId: "",
            side: "Left",
        },
        rightFootMetadata: {
            insoleParameters: rightInsoleParameters,
            footScanParameters: GetDefaultFootScanParameters(),
            measurementId: "",
            side: "Right",
        },
    };
    UpdateShellModifications(leftInsoleParameters, leftFootParameters, rightInsoleParameters, rightFootParameters, prescription.shellModifications, prescription.uiContextData);
    UpdatePosting(leftInsoleParameters, rightInsoleParameters, prescription.postingOptions);
    if (prescription.shellModifications.heelCutout && prescription.shellModifications.heelCutout !== "none") {
        // When L, R, or Both are enabled, also move "embossedTextOffset" to middle of insole.
        // Opposite insole without cutout should also have its embossedText moved to middle for symmetry.
        for (const sideMetadata of [converted.leftFootMetadata, converted.rightFootMetadata]) {
            (_a = sideMetadata.exportParameters) !== null && _a !== void 0 ? _a : (sideMetadata.exportParameters = {});
            sideMetadata.exportParameters.embossedTextOffset = DeepClone(middleEmbossedTextOffset);
        }
    }
    return converted;
}
function CheckCompatibleTools(prescription) {
    // Mortons + first ray cutout + sulcus combinations are already handled in the engine,
    // only the prescription-specific cases are checked here
    const sideMask = {
        none: 0,
        left: 1,
        right: 2,
        both: 3,
    };
    // Cutout at first met head (which is not the same as first ray cutout) is incompatible with morton's extension
    if (sideMask[prescription.shellModifications.cutoutAndFirst] &
        sideMask[prescription.shellModifications.mortonsExtension.side]) {
        throw new Error("Cutout at 1st met head is not allowed when Morton's extension is enabled");
    }
}
//# sourceMappingURL=adapter-client.js.map